import { cn } from '../../lib/cn';
import { Card, Badge, Button, ConfidenceIndicator } from '../ui';
import type { DecisionItem } from '../../rolexp/framework';

type Props = {
  decisions?: DecisionItem[];
  className?: string;
};

export function DecisionCenterPanel({ decisions = [], className }: Props) {
  return (
    <Card className={cn(className)}>
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Decision Center</p>
      <p className="mt-0.5 text-sm text-slate-600 dark:text-slate-400">Today's decisions and pending approvals</p>
      <ul className="mt-4 space-y-3">
        {decisions.map((d) => (
          <li key={d.id} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <div className="flex flex-wrap items-center gap-2">
                  <Badge variant={d.category === 'critical' ? 'error' : d.category === 'high_impact' ? 'warning' : 'default'}>
                    {d.category.replace(/_/g, ' ')}
                  </Badge>
                  {d.source_module && <span className="text-[10px] text-slate-400">{d.source_module}</span>}
                </div>
                <p className="mt-1 text-sm font-medium text-slate-900 dark:text-slate-100">{d.title}</p>
                {d.impact && <p className="mt-0.5 text-xs text-slate-500">Impact: {d.impact}</p>}
              </div>
              {d.confidence != null && <ConfidenceIndicator score={d.confidence} size="sm" />}
            </div>
            {d.requires_approval && (
              <div className="mt-2 flex gap-2">
                <Button size="sm">Approve</Button>
                <Button size="sm" variant="secondary">Review</Button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </Card>
  );
}
